import { ca } from '@cian/analytics';
import { IVillageForListPresenterSchema } from '../../repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { IThunkActionCreator } from '../../types/store';
import { generateTrackingPageViewObject, getCustomUrl } from '../../utils/analytics';

export function trackingPhoneEvent(village: IVillageForListPresenterSchema): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();
    ca('eventSite', {
      ...generateTrackingPageViewObject(state, village),
      name: 'oldevent',
      category: 'Phones',
      action: 'Open_listing_KP',
      label: getCustomUrl(village),
      oid: village.id,
    });
  };
}

export function trackingBuilderLinkCLick(village: IVillageForListPresenterSchema): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();
    ca('eventSite', {
      ...generateTrackingPageViewObject(state, village),
      name: 'oldevent',
      category: 'Listing_KP',
      action: 'to_listing_developer',
      label: '',
      oid: village.id,
    });
  };
}
